import Hero from "../../components/Hero/Hero";
import "./AboutRiver.css";
import Heading from "../../components/Heading/Heading";
import SubHeading from "../../components/SubHeading/SubHeading";
import { Link } from "react-router-dom";
import { checkIsTouchscreen } from "../../helpers/general";
import H1 from "../../components/H1/H1";
import ScrollAnimation from "../../components/ScrollAnimation/ScrollAnimation";
import usePageTitle from "../../hooks/usePageTitle";

const AboutRiver = () => {
    usePageTitle("About");

    const teamMembers = [
        {
            name: "Craig Tocknell",
            position: "Founder & Managing Director",
            image: "/images/team/CraigTocknell.jpg",
            linkedIn: "https://www.linkedin.com/in/craigtocknell/",
            description:
                "Craig is the co-founder of River and a seasoned investment and finance executive with over 20 years' experience building and scaling high-performing businesses. Previously, he co-founded an Australian alternative investments group, overseeing its growth to more than A$1 billion AUM. Craig holds an MBA from the University of Oxford, is a CFA Charterholder, and a Fellow of the Association of Chartered Certified Accountants.",
        },
        {
            name: "Derrick Frazier",
            position: "Founder & Managing Director",
            image: "/images/team/DerrickFrazier.jpg",
            linkedIn: "https://www.linkedin.com/in/derrick-frazier-58398b44/",
            description:
                "Derrick is the co-founder of River and a Director of Frazier Companies, his family-owned holding company. He is the visionary behind several private real estate developments, and formerly oversaw product commercialisation in his family business, Magnum Oil Tools, through to a successful strategic sale in 2018. Derrick holds an MBA from the University of Oxford and studied Economics at the University of Oklahoma and Finance at Texas A&M-Corpus Christi.",
        },
        {
            name: "Andrew Tyndale",
            position: "Advisor",
            image: "/images/team/AndrewTyndale.jpg",
            linkedIn: "https://www.linkedin.com/in/andrewtyndale/",
            description:
                "Andrew brings nearly 40 years of financial experience across funds management, impact investing, and investment banking. Based in Australia, he has advised and managed real estate and private credit portfolios, including most recently providing strategy and direction for a $500 million impact-focused property portfolio. Andrew holds a BCom (Honours) from Queen's University in Canada and is a Fulbright Scholar specialising in social impact investment.",
        },
        {
            name: "Daniel McKinlay",
            position: "Advisor",
            image: "/images/team/DanielMcKinlay.jpg",
            linkedIn: "https://www.linkedin.com/in/danielmckinlay1/",
            description:
                "Dan advises family offices on long-term capital growth and intergenerational transfer. Experienced across the UK and Australia, his work centres on structuring capital for performance and purpose, with a focus on private equity, private credit, and philanthropy. He is completing an Executive MBA at the University of Oxford, holds a BSc in Organic Chemistry from the University of Glasgow, and a BDiv in Theology from Moore Theological College.",
        },
        {
            name: "Werner Baumker",
            position: "Advisor",
            image: "/images/team/WernerBaumker.jpg",
            linkedIn: "https://www.linkedin.com/in/wernerbaumker/",
            description:
                "Werner is a strategic leader with executive and board experience across family offices and family-owned businesses. He has led global investment strategies spanning real estate, PE, and alternatives. Previously, he led Howard Group's UK expansion and co-founded Grosvenor's global real estate indirect investment platform. Werner holds a PhD and MPhil in Finance from the University of Cambridge, and a BSc in International Business from Warwick Business School.",
        },
    ];

    const expandTeamMember = (index) => {
        var isExpanded = false;

        if (checkIsTouchscreen()) {
            isExpanded = document
                .getElementsByClassName("teamMember")
                [index].classList.contains("expanded");
        }

        const members = document.getElementsByClassName("teamMember");

        unexpandTeamMembers();

        const member = members[index];
        if (isExpanded) {
            member.classList.remove("expanded");
        } else {
            member.classList.add("expanded");
        }
    };

    const unexpandTeamMembers = () => {
        const members = document.getElementsByClassName("teamMember");
        for (let i = 0; i < members.length; i++) {
            members[i].classList.remove("expanded");
        }
    };

    if (checkIsTouchscreen()) {
        window.onscroll = function () {
            unexpandTeamMembers();
        };
    }

    return (
        <div className="page-content about-page">
            <Hero name="about-river">
                <H1>About River</H1>
            </Hero>

            <section className="padded">
                <div className="container">
                    <Heading>
                        Founded in 2023, River stewards capital across uncorrelated alternative
                        investment strategies — spanning primary funds, GP stakes, co-investments,
                        and direct investments. Headquartered in London, with offices in the US and
                        Australia, we bring global reach with a focused lens.
                    </Heading>

                    <SubHeading>
                        "River is where capital meets creativity — bridging finance with
                        design-thinking to craft investments as intentionally as an architect shapes
                        space or an artist shapes form."
                    </SubHeading>

                    <div className="spacer"></div>

                    <Heading>Our team</Heading>

                    <div className="teamMembers">
                        {teamMembers.map((member, index) => (
                            <ScrollAnimation key={index} type="revealUp fade" delay={index * 100}>
                                <div
                                    className="teamMember"
                                    key={index}
                                    style={{ backgroundImage: `url(${member.image})` }}
                                    onClick={() => expandTeamMember(index)}
                                    onMouseEnter={() => expandTeamMember(index)}
                                    onMouseLeave={unexpandTeamMembers}
                                >
                                    <div className="details">
                                        <div className="name-and-position">
                                            <div className="name">{member.name}</div>

                                            <div className="position">{member.position}</div>
                                        </div>

                                        <div className="description">
                                            {member.description}

                                            <div className="linked-in">
                                                <Link
                                                    to={member.linkedIn}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <i className="fa-brands fa-square-linkedin"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ScrollAnimation>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AboutRiver;
